// extracted by mini-css-extract-plugin
export default {"cls1":"GroupCsvInstructions-Cell_cls1__qJ7j6","cls2":"GroupCsvInstructions-Cell_cls2__G28bp GroupCsvInstructions-Cell_cls1__qJ7j6"};